export const INFO = "info"
export const SUCCESS = "success"
export const WARNING = "warning"
export const DANGER = "danger"
export const NEUTRAL = "neutral"
export const INVALID = "invalid"
export const BRAND = "brand"

export const KEYCODES = Object.freeze({
  TAB: 9,
  RETURN: 13,
  ESC: 27,
  SPACE: 32,
  PAGEUP: 33,
  PAGEDOWN: 34,
  END: 35,
  HOME: 36,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
})

export const ID_PREFIX = "sphlt-"
